import {api, apiExternal, ApiListResponse, commonApiWrapper, commonExternalWrapper} from '@/services/common-api';
import {ICheckoutPayload, IEventTicketCategory} from '@/app/dashboard/models/EventTicketCategory';
import {IResaleTicket, ITicket} from '@/app/dashboard/models/Ticket';
import {AffiliateLink} from "@/app/events/store/single-page.store";
import {SeatArrangementResponse} from "@/app/dashboard/models/Seating";

interface TicketCategory {
    id: string;
    quantity: number;
}

export const getEventTicketsCategoryByEventId = (eventId: string) => commonApiWrapper<ApiListResponse<IEventTicketCategory>>(api.get(`/ticket-category/event/${eventId}`));

export const getCheckoutObject = (ticketCategories: TicketCategory[], affiliateLink: AffiliateLink, coupon?: string,) => commonApiWrapper<ICheckoutPayload>(api.post(`payments/checkout-data`, {
    ticketCategories,
    coupon,
    ...affiliateLink,
}))

export const getResaleCheckoutObject = (ticketId: string) => commonApiWrapper<ICheckoutPayload>(api.post(`payments/resale-checkout-data`, {ticketId}))

export const getMyTickets = () => commonApiWrapper<ApiListResponse<ITicket>>(api.get('ticket/all'))

export const getMyActiveTickets = (offset = 0, limit = 2) => commonApiWrapper<ApiListResponse<ITicket>>(api.get('ticket/my/active', {
    params: {
        offset,
        limit
    }
}));

export const getMyExpiredTickets = (offset = 0, limit = 2) => commonApiWrapper<ApiListResponse<ITicket>>(api.get('ticket/my/expired', {
    params: {
        offset,
        limit
    }
}));

export const getMyResaleTickets = (offset = 0, limit = 2) => commonApiWrapper<ApiListResponse<IResaleTicket>>(api.get('ticket/my/resale', {
    params: {
        offset,
        limit
    }
}));

export const resaleTicket = (ticketId: string, resaleAmount: number) => commonApiWrapper<ApiListResponse<ITicket>>(api.post('ticket/resale', {
    ticketId,
    resaleAmount
}))

export const reActiveTicketApi = (ticketId: string) => commonApiWrapper<ITicket>(api.post(`ticket/resale/revert/${ticketId}`))

export const getAllResaleTickets = (offset = 0, limit = 5, keyWord = '') =>
    commonApiWrapper<ApiListResponse<IResaleTicket>>(
        api.get('ticket/resale/all', {params: {offset, limit, keyWord}})
    );

export const getTicketFromQRCode = (qrCode: string) => commonApiWrapper<ITicket>(api.get('ticket/qr-validate', {params: {qrCode}}))

export const freeCheckout = (paymentRecordId: string) => commonApiWrapper(api.post('payments/free-checkout', {
    paymentRecordId
}))


export const downloadTicket = (filePath: string) => commonExternalWrapper<Blob>(apiExternal.get(filePath, {responseType: 'blob'}))



export const getSeatingByEventId = async (eventId: string) =>
    commonApiWrapper<SeatArrangementResponse>(
        api.get(`seat-arrangement/events/${eventId}/public`)
    );

export const generateDynamicQrCodeAPI = (ticketId: string) => commonApiWrapper<{ dynamicQrCode: string, expireTime: number }>(api.get(`ticket/generate/${ticketId}`));
